<template>
  <div>
    <InfoAlert :inline="true" type="inspiration" />
    <TopContentMenu />
    <CarouselBanner type="inspiration" />
    <div name="grid" class="flex justify-center mx-auto">
      <CategoryDropdownSidebar :type="CATEGORY_TYPE.CONTENT" />
      <main class="flex-1 sm:flex-none">
        <ContentFeed />
      </main>
    </div>
  </div>
</template>

<script setup>
import { CATEGORY_TYPE } from "@utils/constants";
import { ROUTES } from "@utils/routes";
import { sitePages } from "@settings/site-pages.settings";
import CarouselBanner from "@components/common/carousel-banner";
import CategoryDropdownSidebar from "@components/category/category-dropdown-sidebar";
import ContentFeed from "@components/content/content-feed";
import TopContentMenu from "@components/category/top-content-menu";

definePageMeta({
  layout: 'shop-layout'
});

defineI18nRoute({
  paths: {
    cs: '/inspirace',
    en: '/inspiration',
    sk: '/inspiracia',
    pl: '/inspiracja',
    de: '/inspiration'
  }
});

const { t } = useI18n();
const config = useRuntimeConfig();
const canonical = config.public.appBaseUrl + translatePath(ROUTES.CODE.INSPIRATION);
const { title: seoTitle, ogUrl } = useFilterSeoTitle(() => t(sitePages[config.public.layoutDesign].inspiration[0].heading));

useHead({ link: [ { rel: 'canonical', href: canonical } ] });
useSeoMeta({
  title: () => seoTitle.value,
  ogTitle: () => seoTitle.value,
  description: t(sitePages[config.public.layoutDesign].inspiration[0].subheading),
  ogDescription: t(sitePages[config.public.layoutDesign].inspiration[0].subheading),
  ogImage: `${config.public.appBaseUrl}${sitePages[config.public.layoutDesign].inspiration[0].image}`,
  ogType: `${sitePages[config.public.layoutDesign].type}`,
  ogUrl: () => ogUrl.value
});

</script>
